import { usePasteConfig, type InputTableColumn } from '@/components/custom/erp';
import type { PasteResolverConfig } from '../../../types';

interface UseDetailPasteProps {
  columns: InputTableColumn[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (configs: Record<string, PasteResolverConfig>) => void;
}

export const useDetailPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
